<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <blinds-table
                    ref="blindsTable"
                    :measureUnits="measure_units"
                >
                </blinds-table>

                <removed-items-table
                    ref="removedItemsTable"
                    :measureUnits="measure_units"
                >
                </removed-items-table>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import BlindsTable from '@/components/pages/project/blinds_and_removed_items/blinds_table.vue';
import RemovedItemsTable from '@/components/pages/project/blinds_and_removed_items/removed_items_table.vue';

export default {
    name: 'blinds_and_removed_items',
    components: {
        BlindsTable,
        RemovedItemsTable,
    },
    data () {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.blinds_and_removed_items.title'),
                    active: true
                }
            ],
        }
    },
    mounted () {
    },
    computed: {
		measure_units: {
			get: function () {
				let measure_units = this.$store.getters.getMeasureUnits;
				return measure_units;
			}
		},
	},
	watch: {
		measure_units: {
			immediate: true,
			deep: true,
			handler(newVal, oldVal) {
			}
		}
	},
    methods: {
        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/blinds_and_removed_items/blinds_and_removed_items.vue